
import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { SEOSettings } from '@/components/admin/seo/types';

interface SEOFormProps {
  settings: SEOSettings;
  loading: boolean;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const SEOForm: React.FC<SEOFormProps> = ({ settings, loading, handleInputChange, handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl">
      <div className="space-y-2">
        <Label htmlFor="title">Website Title</Label>
        <Input
          id="title"
          name="title"
          value={settings.title}
          onChange={handleInputChange}
          placeholder="Main website title"
          disabled={loading}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="description">Meta Description</Label>
        <Textarea
          id="description"
          name="description"
          value={settings.description}
          onChange={handleInputChange}
          placeholder="Brief website description for search engines"
          rows={3}
          disabled={loading}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="keywords">Meta Keywords</Label>
        <Input
          id="keywords"
          name="keywords"
          value={settings.keywords}
          onChange={handleInputChange}
          placeholder="Keywords separated by commas"
          disabled={loading}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="google_analytics_id">Google Analytics ID</Label>
        <Input
          id="google_analytics_id"
          name="google_analytics_id"
          value={settings.google_analytics_id}
          onChange={handleInputChange}
          placeholder="GA-XXXXXXXXXX"
          disabled={loading}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="google_site_verification">Google Site Verification</Label>
        <Input
          id="google_site_verification"
          name="google_site_verification"
          value={settings.google_site_verification}
          onChange={handleInputChange}
          placeholder="Meta verification code"
          disabled={loading}
        />
      </div>

      <Button type="submit" className="w-full" disabled={loading}>
        {loading ? (
          <>
            <div className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
            Saving...
          </>
        ) : (
          <>
            <Save className="w-4 h-4 mr-2" />
            Save SEO Settings
          </>
        )}
      </Button>
    </form>
  );
};

export default SEOForm;
